<template>
  <div>
    <el-form :model="messageData" :rules="rules" ref="messageData" label-width="100px">
      <el-form-item label="接收用户">
        <el-select class="select_container" v-model="messageData.targetUsers" multiple placeholder="请选择用户，不选择默认发送给所有用户">
          <el-option
            v-for="item in fofusers"
            :key="item._id"
            :label="item.nickname+'(' + item.email + ')'"
            :value="item._id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消息标题" prop="title">
        <el-input v-model="messageData.title" placeholder="请输入消息标题"></el-input>
      </el-form-item>
      <el-form-item label="消息内容" prop="content">
        <el-input v-model="messageData.content" placeholder="请输入消息内容"></el-input>
      </el-form-item>
      <el-form-item label="消息链接" prop="url">
        <el-input v-model="messageData.url" placeholder="https://"></el-input>
      </el-form-item>
      <el-form-item label="优先级" prop="priority">
        <el-input-number v-model="messageData.priority" :min="1" :max="10"></el-input-number>
      </el-form-item>
      <el-form-item label="定时发送">
        <el-switch :span="6" v-model="messageData.isReserve"></el-switch>
      </el-form-item>
      <el-form-item label="设置时间">
        <el-col :span="11" :xs="22">
          <el-date-picker :disabled="!messageData.isReserve" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="date" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="item-split" :span="2">-</el-col>
        <el-col :span="11" :xs="22">
          <el-time-picker :disabled="!messageData.isReserve" value-format="HH:mm:ss" placeholder="选择时间" v-model="time" style="width: 100%;"></el-time-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="发送媒介" prop="mediums">
        <el-checkbox-group v-model="messageData.mediums">
          <el-checkbox label="安卓版 App" name="mediums"></el-checkbox>
          <el-checkbox label="iPhone 版 App" name="mediums"></el-checkbox>
          <el-checkbox label="小程序" name="mediums"></el-checkbox>
          <el-checkbox label="公众号" name="mediums"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validate">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditMessage',
  props: {
    messageData: Object,
    submitData: Function
  },
  data () {
    return {
      date: '',
      time: '',
      targetUsers: [],
      fofusers: [],
      rules: {
        title: [
          { required: true, message: '请输入消息标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入消息内容', trigger: 'blur' }
        ],
        // url: [
        //   { required: true, message: '请输入消息链接', trigger: 'blur' }
        // ],
        mediums: [
          { type: 'array', required: true, message: '请至少选择一个发送媒介', trigger: 'change' }
        ]
      }
    }
  },
  async created () {
    let { fofusers } = await this.$http.get('/fofusers/')
    this.fofusers = fofusers
    this.date = this.messageData.date
    this.time = this.messageData.time
  },
  methods: {
    validate () {
      this.messageData.date = this.date
      this.messageData.time = this.time
      this.$refs.messageData.validate(async (status, rule) => {
        if (this.messageData.isReserve) {
          if (!this.messageData.date) {
            this.$message({
              message: '请输入定时时间',
              type: 'warning'
            })
            return
          }
          this.messageData.reserveTime = null
        } else {
          this.messageData.reserveTime = null
          this.messageData.date = null
          this.messageData.time = null
        }
        if (status) {
          const resp = await this.submitData()
          if (resp.message) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: resp.error,
              type: 'warning'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.select_container {
  display: block;
}

.item-split {
  text-align: center;
}
</style>
